import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PageSEO } from "@/components/PageSEO";
import { API } from "@/lib/constants";

/* Link «Disdici l'abbonamento» delle email: porta al portale clienti di Stripe. */

const QmdpAbbonamentoPage = () => {
  const { codice } = useParams();
  const [stato, setStato] = useState("apertura");

  useEffect(() => {
    axios.get(`${API}/qmdp/${codice}/portale`)
      .then(({ data }) => { window.location.replace(data.url); })
      .catch(() => setStato("non-trovata"));
  }, [codice]);

  return (
    <main className="pt-32 pb-24 min-h-screen bg-[#FAF8F5]" data-testid="qmdp-abbonamento-page">
      <PageSEO title="Il tuo abbonamento | Quanto Mettere da Parte" description="Gestione dell'abbonamento." noindex />
      <div className="max-w-xl mx-auto px-6 text-center">
        {stato === "apertura" ? (
          <p className="text-[#64708A]" data-testid="qmdp-portale-apertura">Ti stiamo portando alla pagina sicura di Stripe…</p>
        ) : (
          <div data-testid="qmdp-portale-non-trovata">
            <h1 className="font-heading text-4xl text-[#0D1527] mb-4">PAGINA NON TROVATA</h1>
            <p className="text-[#4A5568]">
              Il link potrebbe essere incompleto. Apri il link dall'ultima email che ti abbiamo mandato oppure scrivi a{" "}
              <a className="text-[#8A6A28] underline" href="mailto:assistenza@casalisilvia.com">assistenza@casalisilvia.com</a>.
            </p>
          </div>
        )}
      </div>
    </main>
  );
};

export default QmdpAbbonamentoPage;
